export default __webpack_public_path__ + "static/media/USX.77ae3214.svg";